// src/components/PatientHeader.js
import React from "react";
import { Box } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

// PatientHeader Component
const PatientHeader = ({
  fullName,
  dob,
  lastPcpVisit,
  opportunityScore,
  erVisits,
  admits,
  age,
}) => {
  // Global font size style
  const fontSizeStyle = { fontSize: "1rem" };

  return (
    <Box marginBottom={3}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap={2}
      >
        {/* Left Section with Icon and Title */}
        <Box display="flex" alignItems="center" gap={1}>
          <PersonIcon fontSize="medium" />
          <h3 style={{ ...fontSizeStyle, margin: 0 }}>
            Patient Profile: {fullName}
          </h3>
        </Box>
        {/* Right Section for Patient Age */}
        <h3 style={{ ...fontSizeStyle, margin: 0 }}>Age: {age}</h3>
      </Box>
      {/* Divide into Two Columns */}
      <Box display="flex" justifyContent="space-between" marginTop={2}>
        {/* Column 1 */}
        <Box display="flex" flexDirection="column" gap={1}>
          <p style={fontSizeStyle}>
            <b>DOB:</b> {dob}
          </p>
          <p style={fontSizeStyle}>
            <b>Last PCP Visit:</b> {lastPcpVisit}
          </p>
          <p style={fontSizeStyle}>
            <b>Opportunity Score:</b> {opportunityScore}
          </p>
        </Box>
        {/* Column 2 */}
        <Box display="flex" flexDirection="column" gap={1}>
          <p style={fontSizeStyle}>
            <b>ER Visits (past 6 mos):</b> {erVisits}
          </p>
          <p style={fontSizeStyle}>
            <b>Admits (past 6 mos):</b> {admits}
          </p>
        </Box>
      </Box>
    </Box>
  );
};

export default PatientHeader;
